import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import windowSize from 'react-window-size';
import styled from 'styled-components';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { appTheme } from '../../theme';

const SuccessSnackbarContent = styled(SnackbarContent)`
  background-color: ${appTheme.system.white};
  color: ${appTheme.system.title};

  > div {
    display: flex;
  }
`;

const Message = styled.div`
  align-items: center;
  display: inline-flex;
  font-size: 1.25em;
`;

const MessageIcon = styled(CheckCircleIcon)`
  margin-right: ${appTheme.spacing.default};
`;

function SuccessSnackbarContentWrapper({ message, onClose, ...rest }) {
  return (
    <SuccessSnackbarContent
      {...rest}
      action={[
        <IconButton
          aria-label="Close"
          color="inherit"
          key="close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
      aria-describedby="client-snackbar"
      message={
        <Message id="client-snackbar">
          <MessageIcon />
          {message}
        </Message>
      }
    />
  );
}

SuccessSnackbarContentWrapper.propTypes = {
  message: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

class SuccessSnackbar extends React.Component {
  state = {
    isOpen: this.props.isOpen,
  };

  handleClick = () => {
    this.setState({ isOpen: true });
  };

  handleClose = (event, reason) => {
    this.setState({ isOpen: false });
  };

  render() {
    const { message, onExited, windowWidth } = this.props;
    const isMobile = windowWidth <= 480;

    return (
      <Snackbar
        anchorOrigin={
          isMobile
            ? {
                vertical: 'bottom',
                horizontal: 'center',
              }
            : {
                vertical: 'top',
                horizontal: 'center',
              }
        }
        autoHideDuration={5000}
        onClose={this.handleClose}
        onExited={onExited}
        open={this.state.isOpen}
      >
        <SuccessSnackbarContentWrapper
          message={message}
          onClose={this.handleClose}
        />
      </Snackbar>
    );
  }
}

SuccessSnackbar.propTypes = {
  message: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,

  isOpen: PropTypes.bool,
  onExited: PropTypes.func,
};

SuccessSnackbar.defaultProps = {
  isOpen: false,
  onExited: noop,
};

export default windowSize(SuccessSnackbar);



// WEBPACK FOOTER //
// ./src/modules/common/SuccessMessage.js